import { Reducer } from 'redux';
import { IBroadcast, IBroadcastActionTypes } from './Types';

const initialBroadcast: IBroadcast = {
  response: null,
  isLoading: false,
  error: '',
  previousResponse: null,
};

const reducer: Reducer<IBroadcast> = (state = initialBroadcast, action) => {
  switch (action.type) {
    case IBroadcastActionTypes.GET_BROADCAST: {
      return {
        ...state,
        isLoading: true,
        error: '',
        response: null,
      };
    }
    case IBroadcastActionTypes.GET_BROADCAST_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        response: null,
      };
    }
    case IBroadcastActionTypes.GET_BROADCAST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: '',
        response: action.payload,
        previousResponse: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as BroadcastReducer };
